//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Fragment } from "vue-fragment";
import RichTextEditor from "@Shared/utils/rich-text-editor";
import { isObject } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TextArgument",
  components: {
    Fragment
  },
  props: {
    value: {
      type: [String, Object],
      default: ""
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const localValue = isObject(this.value) ? "" : RichTextEditor.sanitizeRichTextWithoutEmbeddedMedia(this.value);
    return {
      localValue
    };
  },
  watch: {
    value(newValue) {
      if (newValue !== this.localValue) {
        const sanitizedValue = RichTextEditor.sanitizeRichTextWithoutEmbeddedMedia(newValue);
        this.localValue = sanitizedValue;
        if (this.editor) {
          this.editor.setHTML(this.localValue);
        }
      }
    },
    localValue() {
      this.$emit("input", this.localValue);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      $(".note-codable").attr("id", "text");
    });
  },
  methods: {
    init() {
      const target = $(this.$refs.textField);
      this.editor = new RichTextEditor(target, {
        airMode: true,
        height: "10vw",
        substitutionHints: false,
        showMergeTags: false,
        loadPreferences: false,
        blockPastedImages: false,
        sanitizeContent: RichTextEditor.sanitizeRichTextWithoutEmbeddedMedia,
        callbacks: {
          onChange: this.handleEditorChange
        }
      });
      this.$nextTick(() => {
        target.next(".note-editor").addClass("trigger-select form-control h-100");
      });
    },
    handleEditorChange(_, value) {
      if (this.localValue !== value) {
        this.localValue = value;
      }
    }
  }
});